import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import NwFooter from './NwFooter';
import NwHeaderMobile from './NwHeaderMobile';

const Wrapper = styled(Layout)`

    color: ${props => props.theme.TextColor};
    background-color: ${props => props.theme.LayoutBodyBackground};
    transition: all 0.2s;

    .ant-layout-content {
        margin: 1rem 1rem 3rem 1rem;
    }
`;

const NwBookLayoutMobile = ({
    packageInfo,
    children
}) => {

    return (
        <Wrapper>
            <NwHeaderMobile packageInfo={packageInfo} />
            {children}
            <NwFooter />
        </Wrapper>
    )
};

export default NwBookLayoutMobile;
